import React from 'react';
import nseAcademy from "../../asset/images/certificates/nse-academy.jpg";
import irda from "../../asset/images/certificates/irda.jpg";
import nism from "../../asset/images/certificates/nism.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CertificateIssuers(){

    const certificateSlider = {
        dots: false,
        arrows: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,

        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
            },
        },
        ],
    }
    
    return(

        <div className="certificate-issuers col-sm-12 col-md-6 col-lg-6">
                        <div className="card-box">
                            <div className="card-title">
                                <h2>Certificate Issuers</h2>
                            </div>
                            <Slider {...certificateSlider} className="certi-issuers-item-wrapper certificate-card-slider" >

                                <div className="certi-issuers-img-wrapper">
                                    <img src={nseAcademy} alt="nse-academy" className="certi-issuers-img" />
                                </div>
                                <div className="certi-issuers-img-wrapper">
                                    <img src={irda} alt="irda" className="certi-issuers-img" />
                                </div>
                                <div className="certi-issuers-img-wrapper">
                                    <img src={nism} alt="nism" className="certi-issuers-img" />
                                </div>
                                <div className="certi-issuers-img-wrapper">
                                    <img src={irda} alt="irda" className="certi-issuers-img" />
                                </div>
                                <div className="certi-issuers-img-wrapper">
                                    <img src={nism} alt="nism" className="certi-issuers-img" />
                                </div>
                                <div className="certi-issuers-img-wrapper">
                                    <img src={nseAcademy} alt="nism" className="certi-issuers-img" />
                                </div>
                                <div className="certi-issuers-img-wrapper">
                                    <img src={irda} alt="nism" className="certi-issuers-img" />
                                </div>

                            </Slider>

                        </div>
                    </div>
    )
}
export default CertificateIssuers;